import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { LocalStorageService } from "../../../services";
import { ResumeNews } from "../../../assets/logos/icons";
import { TipSignature } from "../../../assets/logos";
import { Dialog } from "@progress/kendo-react-dialogs";

import "./post-blog.css";

const PostBlogPure = (props) => {
  const [lastPost, setLastPost] = useState({
    lastPostImg: "",
    lastPostDate: "",
    lastPostTitle: "",
    lastPostDescription: "",
    lastPostSeeMore: "",
  });
  const localStorageService = new LocalStorageService();
  useEffect(async () => {
    let blog = localStorageService.getLocalStorageItem("lastPostInfo");
    let imgBlog = localStorageService.getLocalStorageItem("lastPostInfoImg");
    let postDate = localStorageService.getLocalStorageItem("postDate");

    if (blog && blog[0]) {
      let descriptionHTML = blog[0].excerpt.rendered.split("p>")[1];
      let postDescriptionSplit = descriptionHTML.slice(0, -235);

      setLastPost({
        lastPostDate: postDate,
        lastPostTitle: blog[0].title.rendered,
        lastPostDescription: postDescriptionSplit,
        lastPostSeeMore: blog[0].link,
        lastPostImg: imgBlog,
      });
    }
  }, []);

  //Dialog legal tips
  const [visible, setVisible] = useState(false);

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const { t } = useTranslation();

  return (
    <Grid
      className={
        props.footer === true ? "container-postBlog" : "helpSection-postBlog"
      }
    >
      {lastPost.lastPostImg === "" ? (
        <div className="postBlogPure-textPadding">

          {/* <img src={ResumeNews} className="postBlogPure-resume-img" /> */}
          <span className="postBlogPure-title">TIPS LEGALES</span>
          <div className="postBlogPure-legalTips">
            <img src={TipSignature} className="postBlogPure-resume-img" />
            <div className="postBlogPure-text-container">
              <span className="postBlogPure-text">
                {t("postBlogPure.descriptionLegalTips")} 4-CUATRO AÑOS {t("postBlogPure.descriptionLegalTipsTwo")}
              </span>
              <a>
                <p className="postBlogPure-seeMore" onClick={toggleDialog}>
                  {t("postBlogPure.seeMore")}
                </p>
              </a>
            </div>
          </div>
        </div>
      ) : (
        <Grid xs={12} lg={12} md={12} sm={12} es={4}>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={4}
            className="container-imgBlog"
          >
            <img
              src={lastPost.lastPostImg}
              className={
                props.footer === false ? "imgBlog-style" : "imgBlog-helpSection"
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={4}
            className={
              props.footer === true
                ? "descriptionBlog-txt-container"
                : "descriptionBlog-helpSection"
            }
          >
            {/* <div className="rowTextStyles">
                <h3 className="information-contact-invited-label-first">{lastPost.lastPostTitle}</h3>
              </div> */}
            <p
              className={
                props.footer === true
                  ? "postBlog-date"
                  : "postBlog-date-helpSection"
              }
            >
              {lastPost.lastPostDate}
            </p>
            <div className="rowTextStyles">
              <p
                className="information-contact-invited-label-second"
                dangerouslySetInnerHTML={{
                  __html: lastPost.lastPostDescription,
                }}
              ></p>
            </div>
            <div className="rowTextStyles">
              <a
                className={
                  props.footer === true
                    ? "readMore-postBlog"
                    : "readMore-postBlog-helpSection"
                }
                href={lastPost.lastPostSeeMore}
                target="_blank"
              >
                Ver más...
              </a>
            </div>
          </Grid>
        </Grid>
      )}
      {visible && (
        <Dialog
          width={590}
          height={500}
          className="dialogTemplatePure-container"
          title={"govo.digital"}
          onClose={toggleDialog}
        >
          <div className="postBlogPure-dialogContent">
            <span className="postBlogPure-titleLegalTips">
              {t("postBlogPure.titleLegalTips")}
            </span>
            <p>
              Los certificados de la EFIRMA que emite el Servicio de
              Administración Tributaria (SAT), tienen una vigencia de
              <b> 4-CUATRO </b>
              AÑOS a partir de su fecha de expedición. Recuerda que una vez
              vencida, no podrías renovarla por medios electrónicos y deberás en
              su caso, obtener nuevamente los certificados de la EFIRMA de forma
              presencial, lo que implicaría la generación de una cita en el
              módulo de servicios tributarios que te corresponda. Recuerda que
              la EFIRMA del SAT puede ser utilizada como Firma Digital Avanzada
              en cualquier documento que requiera tu firma, otorgando la
              característica del “No Repudio” a dicha manifestación de voluntad.
              Ahora bien, si requieres firmar documentos con tu EFIRMA y esta no
              se encuentra vigente, no podrás hacerlo, puesto que nuestro
              sistema validará que dichos certificados están vencidos y por lo
              tanto, no serían válidos para tu proceso de firma. La fecha de
              expedición de tu EFIRMA puede ser consultada en el Comprobante de
              Generación del Certificado Digital de Firma Electrónica que te
              entrega el SAT al momento de obtener tu EFIRMA. ¡Que no se te
              pase!
            </p>
          </div>
        </Dialog>
      )}
    </Grid>
  );
};

export { PostBlogPure as default };
